import React from "react";
import { X, Star, Money, CreditCard } from "@phosphor-icons/react";

const HISTORY_PILL = (status) => (status === "completed" ? "pill-online" : "pill-error");

function PaymentBadge({ method }) {
  if (!method) return null;
  const isCard = method === "card";
  return (
    <span className="inline-flex items-center gap-1 text-xs font-semibold text-slate-600" data-testid="history-payment-method">
      {isCard ? <CreditCard size={14} weight="duotone" /> : <Money size={14} weight="duotone" />}
      {isCard ? "Tarjeta" : "Efectivo"}
    </span>
  );
}

export function PassengerHistorySheet({ history, onClose, onRate, embedded }) {
  const list = (
    <div className="space-y-3 scroll-area">
      {history.length === 0 && <p className="text-slate-500 text-center py-8">Sin viajes aún</p>}
      {history.map((r) => (
        <div key={r.id} className="card" data-testid={`history-item-${r.id}`}>
          <div className="flex justify-between mb-2">
            <span className={`pill ${HISTORY_PILL(r.status)}`}>{r.status}</span>
            <span className="font-bold" data-testid={`history-amount-${r.id}`}>€{(r.final_price || r.estimated_price || 0).toFixed(2)}</span>
          </div>
          <div className="text-sm text-slate-600">{r.pickup_address} → {r.dest_address}</div>
          <div className="flex items-center justify-between mt-1">
            <span className="text-xs text-slate-400">{new Date(r.created_at).toLocaleString()}</span>
            <PaymentBadge method={r.payment_method} />
          </div>
          {r.status === "completed" && !r.reviewed && (
            <button onClick={() => onRate(r)} className="btn-ghost w-full mt-2 text-sm" data-testid={`rate-history-${r.id}`}>
              <Star size={14} className="inline mr-1" weight="fill" /> Calificar viaje
            </button>
          )}
        </div>
      ))}
    </div>
  );

  if (embedded) {
    return (
      <div className="app-section" data-testid="history-section">
        <h2 className="section-title font-display">Mi historial</h2>
        {list}
      </div>
    );
  }

  return (
    <div className="bottom-sheet slide-up" style={{ maxHeight: "70vh", overflow: "auto" }} data-testid="history-sheet">
      <div className="handle" />
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-2xl font-display font-bold">Mi historial</h2>
        <button onClick={onClose} className="w-9 h-9 rounded-full bg-slate-100 flex items-center justify-center"><X size={18} /></button>
      </div>
      {list}
    </div>
  );
}
